import useBeautyFilterStore from 'stores/beautyFilter/beautyFilterStore';
import useBeautyFilterBanubaStore from 'stores/beautyFilter/beautyFilterBanubaStore';

const useBeauty = () => {
  const store = useBeautyFilterStore();
  const { selectedItem: selectedMenuItem } = store.menu;
  const { keys, table, selectedKey, selectedSubKey, setSelectedKey, setSelectedSubKey, resetSelectedKey, resetSelectedSubKey } = store.beauty;
  const { isBeautyKeyUsing, isBeautySubKeyUsing, resetPresetValue, resetBeautyState, setPresetType, isUsingPreset } = useBeautyFilterBanubaStore();

  const handleItemSelect = (key: string) => {
    setSelectedKey(key);
    // preset 선택 시 성별에 따라 자동 선택
    if (key === 'preset') {
      setPresetType(myinfo?.gender === 'male' ? 'withoutEyes' : 'all');
      setSelectedSubKey('preset');
    } else {
      resetSelectedSubKey();
    }
  };

  const handleItemAllReset = () => {
    resetSelectedKey();
    resetSelectedSubKey();
    resetPresetValue();
    resetBeautyState();
  };

  const handleSubItemAllReset = (key: string) => {
    resetBeautyState(key);
    resetSelectedSubKey();
  };

  const isTabVisible = selectedMenuItem.id === 'beauty' && (selectedKey === null || selectedKey === 'preset');

  const isSubTabVisible = (key: string) => selectedMenuItem.id === 'beauty' && selectedKey === key && selectedKey !== 'preset';

  const isItemSelected = (key: string) => selectedKey === key;

  const isSubItemSelected = (subKey: string) => selectedSubKey === subKey;

  const isItemUsing = (key: string) => {
    if (key === 'preset') return isUsingPreset();
    return isBeautyKeyUsing(key);
  };

  const isSubItemUsing = (key: string, subKey: string) => isBeautySubKeyUsing(key, subKey);

  return {
    keys,
    table,
    isTabVisible,
    isSubTabVisible,
    isItemSelected,
    isSubItemSelected,
    isItemUsing,
    isSubItemUsing,
    handleItemSelect,
    handleSubItemSelect: setSelectedSubKey,
    handleItemAllReset,
    handleSubItemAllReset,
  };
};

export default useBeauty;
